
import React from 'react';
import { useLocation } from 'react-router-dom';

const SilentButton = (props: { classes?: any, value: any, isDisabled: any, onClick: any }) => {
    const { isDisabled, value, classes, onClick } = props;

    const handleButtonClick = (e: any) => {
        onClick(e);
    };

    return (
        <button onClick={(e: any) => { handleButtonClick(e) }} className={`${classes} hover:underline cursor-pointer disabled:cursor-not-allowed disabled:no-underline disabled:text-[#b0b0b0]`} disabled={isDisabled}>{value}</button>
    );
};

export default SilentButton;
